module.exports = __webpack_public_path__ + "static/media/icon-zusatzversicherung.7c8b5c8a.svg";